// ISO14001Certification.jsx
import React from "react";

export default function ISO14001Certification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Content */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            ISO 14001 Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            ISO 14001 Environmental Management Certification Support
          </h1>
          <div className="w-20 h-1 bg-green-600 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in ISO 14001 Certification for
            environmental management systems, helping organisations structure
            policies, processes, and records in line with ISO 14001:2015
            requirements.[web:362][web:361]
          </p>
          <p className="text-gray-700">
            The focus is on integrating environmental controls into day‑to‑day
            operations so that legal compliance, risk control, and sustainability
            goals are embedded in a practical EMS.[web:353][web:361]
          </p>
        </div>

        {/* Right: Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-green-500 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/2990650/pexels-photo-2990650.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Landscape and industrial site symbolising environmental management"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents Required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for ISO 14001 Certification
            </h2>
            <p className="text-gray-700 mb-4">
              ISO 14001 requires defined environmental commitments, documented
              controls, and evidence of monitoring and legal compliance.[web:353][web:354]
            </p>
            <div className="bg-gray-50 border border-green-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Environmental policy approved by top management, stating
                  commitments to protection of the environment, compliance
                  obligations, and continual improvement.[web:353][web:354]
                </li>
                <li>
                  Compliance records and EMS evidence, such as legal registers,
                  monitoring and measurement results, evaluation of compliance,
                  internal audit reports, and corrective action records.[web:353][web:354][web:359]
                </li>
                <li>
                  Business details and EMS scope information, including
                  organisational structure, activities, products/services, EMS
                  boundaries, and identified environmental aspects and
                  impacts.[web:353][web:354][web:361]
                </li>
                <li>
                  Operational control and emergency preparedness procedures
                  showing how significant environmental aspects are managed in
                  routine and abnormal situations.[web:353][web:354]
                </li>
              </ul>
            </div>
          </div>

          {/* Why Choose Hawkins & Brooks */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The service is aimed at turning ISO 14001 into a usable EMS that
              supports real environmental performance, not just certification.[web:355][web:361]
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-green-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  EMS Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on interpreting ISO 14001 clauses, identifying
                  environmental aspects and compliance obligations, and defining
                  realistic objectives and programmes.[web:353][web:361]
                </p>
              </div>

              <div className="border-l-4 border-green-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Structured Documentation Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Help in designing policies, procedures, registers, and records
                  so that mandatory ISO 14001 documented information is covered
                  without unnecessary paperwork.[web:353][web:354][web:355]
                </p>
              </div>

              <div className="border-l-4 border-green-600 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Reliable Professional Service
                </h3>
                <p className="text-gray-700 text-sm">
                  Ongoing advisory through implementation, internal audits, and
                  external certification audits, supporting continual
                  improvement and surveillance compliance.[web:359][web:361]
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-green-600 text-green-700 font-medium hover:bg-green-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
